import {Component, Input} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {IEntityLabelPair} from '../../services/bullhorn-meta.service';
import {BullhornIconService} from '../../services/bullhorn.icon.service';
import {BullhornEntityType} from '../../types/bullhorn/bullhorn-entity-type';

@Component({
    selector: 'app-entity-type-picker',
    templateUrl: './entity-type-picker.component.html',
    styleUrls: ['./entity-type-picker.component.scss'],
    standalone: false
})
export class EntityTypePickerComponent {

  @Input() entitiesToRender!: IEntityLabelPair[];
  @Input() form!: FormGroup;
  constructor(private bullhornIconService: BullhornIconService) {}

  getIcon(objectName: string): string {
    return this.bullhornIconService.getIcon(objectName as BullhornEntityType);
  }
}
